"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ICD10_CODE_PATTERN () {
        return _icd10search.ICD10_CODE_PATTERN;
    },
    get Icd10CodeSchema () {
        return _icd10search.Icd10CodeSchema;
    },
    get Icd10SearchItemSchema () {
        return _icd10search.Icd10SearchItemSchema;
    },
    get Icd10SearchRequestSchema () {
        return _icd10search.Icd10SearchRequestSchema;
    },
    get Icd10SearchResponseSchema () {
        return _icd10search.Icd10SearchResponseSchema;
    }
});
const _icd10search = require("./icd10-search");
